import { PayloadAction } from "@reduxjs/toolkit";
import { ICustomizeColumns } from "app/types";
import { set } from "lodash";
import { createSlice } from "utils/@reduxjs/toolkit";
import { GroupByTypeEnum, TicketGroup } from "../../../types";
import { IBoardState } from "../types";
import { defaultBoardForm, initialState } from "./initialState";

const useClinicSlice = createSlice({
  name: "boardSetting",
  initialState,
  reducers: {
    // get board request
    getBoard: (state, action: PayloadAction<{ id: string }>) => {
      state.isBoardLoading = true;
    },
    updateBoard: (
      state,
      action: PayloadAction<{ id: string; callback: () => void }>
    ) => {
      state.isBoardCreate = true;
    },

    setBoardLoading: (state, action: PayloadAction<boolean>) => {
      state.isBoardLoading = action.payload;
    },
    setIsBoardCreate: (state, action: PayloadAction<boolean>) => {
      state.isBoardCreate = action.payload;
    },
    setBoardFormData: (state, action: PayloadAction<IBoardState>) => {
      state.boardForm = action.payload;
    },
    setDraftBoardFormData: (state, action: PayloadAction<IBoardState>) => {
      state.draftBoardForm = {
      ...action.payload,
      groups: action.payload.groups.map(group => ({
      ...group,
      tickets: [...group.tickets],
        })),
      };
    },
    clearDraftFrom: (state) => {
      state.draftBoardForm = state.boardForm;
    },
    setBoardCustomizeCards: (
      state,
      action: PayloadAction<Array<ICustomizeColumns>>
    ) => {
      state.draftBoardForm.customizeCards = action.payload;
    },
    setBoardVisibleGroups: (
      state,
      action: PayloadAction<Array<TicketGroup>>
    ) => {
      state.draftBoardForm.visibleGroups = action.payload;
    },
    setClearBoardForm: (state) => {
      state.boardForm = { ...defaultBoardForm };
    },
    setClearDraftFrom: (state) => {
      state.draftBoardForm = { ...defaultBoardForm };
    },
    setBoardsFormValue: (
      state,
      action: PayloadAction<{ name: string; value: string }>
    ) => {
      set(state, `draftBoardForm.${action.payload.name}`, action.payload.value);
    },
    setBoardsGroupVisibility: (state, action: PayloadAction<number>) => {
      state.draftBoardForm.visibleGroups[action.payload].isVisible =
        !state.draftBoardForm.visibleGroups[action.payload].isVisible;
    },
    setBoardsGroupAllVisibility: (state, action: PayloadAction<boolean>) => {
      state.draftBoardForm.visibleGroups.forEach((item) => {
        item.isVisible = action.payload;
      });
    },
    setVisibleGroupOrder: (state, action: PayloadAction<TicketGroup[]>) => {
      state.draftBoardForm.visibleGroups = action.payload;
    },
    setBoardsCustomizeCard: (state, action: PayloadAction<GroupByTypeEnum>) => {
      const index = state.draftBoardForm.customizeCards.findIndex(
        (card) => card.type === action.payload
      );

      if (index !== -1) {
        state.draftBoardForm.customizeCards[index].isVisible =
          !state.draftBoardForm.customizeCards[index].isVisible;
      }
    },
    setBoardsCustomizeCardAllVisibility: (
      state,
      action: PayloadAction<boolean>
    ) => {
      state.draftBoardForm.customizeCards.forEach((item) => {
        item.isVisible = action.payload;
      });
    },
    setCustomizeCardOrder: (
      state,
      action: PayloadAction<ICustomizeColumns[]>
    ) => {
      state.draftBoardForm.customizeCards = action.payload;
    },
  },
});

export const { reducer, actions, name: sliceKey } = useClinicSlice;
